<template>
    <div class="invoice-folder-tags" v-if="invoice">
        <small class="text-muted mr-2">{{ $t('folders_label') }}</small>
        <span v-for="folderId in (invoice.folder_ids || [])"
              :key="folderId"
              class="invoice-folder-tags__tag">
            {{ getFolderName(folderId) }}
            <i class="material-icons material-icons-round md-14 invoice-folder-tags__remove"
               @click="removeFromFolder(folderId)">close</i>
        </span>
        <span class="invoice-folder-tags__add" v-if="availableFolders.length > 0">
            <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                    <i class="material-icons material-icons-round md-16">add</i>
                </template>
                <b-dropdown-item v-for="folder in availableFolders"
                                 :key="folder.id"
                                 @click="addToFolder(folder.id)">
                    {{ folder.name }}
                </b-dropdown-item>
            </b-dropdown>
        </span>
        <span v-if="(invoice.folder_ids || []).length === 0 && availableFolders.length === 0">
            <small class="text-muted">{{ $t('no_folders_tag') }}</small>
        </span>
    </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import Folder from '@/store/models/folder';

export default {
    name: 'InvoiceFolderTags',
    i18nOptions: { namespaces: 'folders' },
    components: { BDropdown, BDropdownItem },
    props: {
        invoice: { type: Object, required: true },
    },
    computed: {
        allFolders() {
            return Folder.query().where('$isNew', false).get();
        },
        availableFolders() {
            const currentIds = this.invoice.folder_ids || [];
            return this.allFolders.filter(f => !currentIds.includes(f.id));
        },
    },
    methods: {
        getFolderName(folderId) {
            const folder = Folder.find(folderId);
            return folder ? folder.name : 'Unknown';
        },
        async addToFolder(folderId) {
            const currentIds = this.invoice.folder_ids || [];
            const merged = [...new Set([...currentIds, folderId])];
            await this.$store.dispatch('invoices/updateInvoice', {
                invoiceId: this.invoice.id,
                props: { folder_ids: merged },
            });
        },
        async removeFromFolder(folderId) {
            const currentIds = this.invoice.folder_ids || [];
            const filtered = currentIds.filter(id => id !== folderId);
            await this.$store.dispatch('invoices/updateInvoice', {
                invoiceId: this.invoice.id,
                props: { folder_ids: filtered },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-folder-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;

    &__tag {
        display: inline-flex;
        align-items: center;
        background: #e9ecef;
        border-radius: 12px;
        padding: 2px 10px;
        font-size: 12px;
    }

    &__remove {
        cursor: pointer;
        margin-left: 4px;
        color: #868e96;
        &:hover {
            color: #e03131;
        }
    }

    &__add {
        display: inline-flex;
        align-items: center;
    }
}
</style>
